import { type DerivedEventLegacy, SimpleEventTypeLegacy } from '@verantos-dev/types-cohorts';

import { transformSimpleEventTypeToGrammarSimpleEventType } from '../adapters/transformSimpleEventTypeToGrammarSimpleEventType';

export const getNextDerivedEventsForSimpleEventNameChange = (
  derivedEvents: DerivedEventLegacy[],
  referencedEventName: string,
  newReferencedEventName: string,
  newType: SimpleEventTypeLegacy | undefined
) => {
  return derivedEvents.map((derivedEvent) => {
    const nextDerivedEventFilters = derivedEvent.eventFilters.map((eventFilter) => {
      const eventFilterReferenceEventName = eventFilter.eventName.value?.split('::')[1];
      if (
        eventFilterReferenceEventName?.slice(1, eventFilterReferenceEventName.length - 1) ===
        referencedEventName
      ) {
        return {
          ...eventFilter,
          eventName: {
            ...eventFilter.eventName,
            value: `${transformSimpleEventTypeToGrammarSimpleEventType(
              newType
            )}::"${newReferencedEventName}"`,
          },
        };
      }

      return eventFilter;
    });

    return {
      ...derivedEvent,
      eventFilters: nextDerivedEventFilters,
    };
  });
};
